export const DoctorSchedule = {
  provider_name: "",
  start_datetime: null,
  end_datetime: null,
  service_slots: [],
}